import http from "./http";

/* =============================
   GET ALL PURCHASE ORDERS
============================= */
export const getPurchaseOrders = async () => {
  const res = await http.post(
    "purchase_api?action=get_all",
    new URLSearchParams({ action: "get_all" }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return res.data;
};

/* =============================
   ADD PURCHASE ORDER
============================= */
export const addPurchaseOrder = async (payload) => {
  const res = await http.post(
    "purchase_api?action=add",
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
  return res.data;
};

/* =============================
   DELETE PURCHASE ORDER
============================= */
export const deletePurchaseOrder = async (id) => {
  const res = await http.post(
    "purchase_api",
    new URLSearchParams({
      action: "delete",
      id,
    }),
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }
  );
  return res.data;
};
